import { Component, OnInit, Input } from '@angular/core';
import { ModelService } from '../model/model.service';
import { Size } from '../model/enum';

@Component({
  selector: 'app-image-preview-modal',
  templateUrl: './image-preview-modal.component.html',
  styleUrls: ['./image-preview-modal.component.scss']
})
export class ImagePreviewModalComponent implements OnInit {

  @Input() src: string = '';
  @Input() language: string = '';
  @Input() width: Size = Size.lg;
  constructor(
    private modalService:ModelService
  ) { }

  ngOnInit(): void {
  }
  closePopup(){
    this.modalService.close();
  }
}
